import {
  GET_REPORT_PENDING,
  GET_REPORT_FAIL,
  GET_REPORT_SUCCESS,
  GET_REPORT_MANAGERS_PENDING,
  GET_REPORT_MANAGERS_FAIL,
  GET_REPORT_MANAGERS_SUCCESS,
  GET_REPORT_CAMPAIGNS_PENDING,
  GET_REPORT_CAMPAIGNS_FAIL,
  GET_REPORT_CAMPAIGNS_SUCCESS,
  GET_REPORT_SEQUENCES,
  GET_REPORT_ACCOUNTS,
  GET_REPORT_OPPORTUNITIES,
  GET_REPORT_TEMPLATES_PENDING,
  GET_REPORT_TEMPLATES_FAIL,
  GET_REPORT_TEMPLATES_SUCCESS,
  RESET_REPORT,
} from '../actions/reportActions';

const initialState = {
  loading: false,
  loaded: true,
  loadingCSV: false,
  bounced: 0,
  delivered: 0,
  interested: 0,
  opened: 0,
  opted_out: 0,
  replied: 0,
  people_contacted: 0,
  attempted_sends_unique: 0,
  reportParams: {},
  lastPeriod: {
    loading: false,
    loaded: true,
    interested: 0,
    potential_reach: 0,
  },
  report_charts: [],
  total_contacts: 0,
  opportunities: {
    loading: true,
    loaded: false,
    count: null,
    next: null,
    previous: null,
    results: [],
  },
  accounts: {
    loading: true,
    loaded: false,
    count: null,
    next: null,
    previous: null,
    results: [],
  },
  managers: {
    loading: true,
    loaded: false,
    count: null,
    next: null,
    previous: null,
    results: [],
  },
  campaigns: {
    loading: true,
    loaded: false,
    count: null,
    next: null,
    previous: null,
    results: [],
  },
  sequences: {
    loading: true,
    loaded: false,
    count: null,
    next: null,
    previous: null,
    results: [],
  },
  templates: {
    loading: true,
    loaded: false,
    count: null,
    next: null,
    previous: null,
    results: [],
  },
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_REPORT_PENDING:
      return {
        ...state,
        loading: true,
        loaded: false,
        lastPeriod: {
          loading: true,
          loaded: false,
        },
      };
    case GET_REPORT_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        ...action.payload,
        reportParams: action.params,
      };
    }
    case GET_REPORT_FAIL:
      return {
        ...state,
        loading: false,
        loaded: true,
        ...action.payload,
        lastPeriod: {
          loading: false,
          loaded: true,
          interested: 0,
          potential_reach: 0,
        },
      };
    case GET_REPORT_MANAGERS_PENDING:
      return {
        ...state,
        managers: {
          results: [],
          loading: true,
          loaded: false,
        },
      };
    case GET_REPORT_MANAGERS_SUCCESS: {
      return {
        ...state,
        managers: {
          loading: false,
          loaded: true,
          ...action.payload,
        },
      };
    }
    case GET_REPORT_MANAGERS_FAIL:
      return {
        ...state,
        managers: {
          ...state.managers,
          loading: false,
          loaded: true,
        },
      };
    case GET_REPORT_CAMPAIGNS_PENDING:
      return {
        ...state,
        campaigns: {
          results: [],
          loading: true,
          loaded: false,
        },
      };
    case GET_REPORT_CAMPAIGNS_SUCCESS: {
      return {
        ...state,
        campaigns: {
          loading: false,
          loaded: true,
          ...action.payload,
        },
      };
    }
    case GET_REPORT_CAMPAIGNS_FAIL:
      return {
        ...state,
        campaigns: {
          ...state.campaigns,
          loading: false,
          loaded: true,
        },
      };
    case GET_REPORT_SEQUENCES.pending:
      return {
        ...state,
        sequences: {
          results: [],
          loading: true,
          loaded: false,
        },
      };
    case GET_REPORT_SEQUENCES.success:
      return {
        ...state,
        sequences: {
          loading: false,
          loaded: true,
          ...action.payload.data,
        },
      };
    case GET_REPORT_SEQUENCES.error:
      return {
        ...state,
        sequences: {
          loading: false,
          loaded: true,
          ...action.payload,
        },
      };
    case GET_REPORT_ACCOUNTS.pending:
      return {
        ...state,
        accounts: {
          results: [],
          loading: true,
          loaded: false,
        },
      };
    case GET_REPORT_ACCOUNTS.success:
      return {
        ...state,
        accounts: {
          loading: false,
          loaded: true,
          ...action.payload.data,
        },
      };
    case GET_REPORT_ACCOUNTS.error:
      return {
        ...state,
        accounts: {
          loading: false,
          loaded: true,
          ...action.payload,
        },
      };
    case GET_REPORT_OPPORTUNITIES.pending:
      return {
        ...state,
        opportunities: {
          results: [],
          loading: true,
          loaded: false,
        },
      };
    case GET_REPORT_OPPORTUNITIES.success:
      return {
        ...state,
        opportunities: {
          loading: false,
          loaded: true,
          ...action.payload.data,
        },
      };
    case GET_REPORT_OPPORTUNITIES.error:
      return {
        ...state,
        opportunities: {
          loading: false,
          loaded: true,
          ...action.payload,
        },
      };
    case GET_REPORT_TEMPLATES_PENDING:
      return {
        ...state,
        templates: {
          results: [],
          loading: true,
          loaded: false,
        },
      };
    case GET_REPORT_TEMPLATES_SUCCESS: {
      return {
        ...state,
        templates: {
          loading: false,
          loaded: true,
          ...action.payload,
        },
      };
    }
    case GET_REPORT_TEMPLATES_FAIL:
      return {
        ...state,
        templates: {
          ...state.templates,
          loading: false,
          loaded: true,
        },
      };
    case RESET_REPORT:
      return initialState;
    default:
      return state;
  }
}
